// extracted by mini-css-extract-plugin
export default {"button":"BonusButtons__button--slots-Uy9jq"};